var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('OrdersFBACreationUser',{attrs:{"FBA":_vm.FBA},on:{"create":_vm.save,"changeUser":_vm.changeUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }